import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Hero from "../components/CrossPlatformAppDevelopment/Hero";
import DevelopServices from "../components/CrossPlatformAppDevelopment/DevelopServices";
import Technology from "../components/CrossPlatformAppDevelopment/Technology";
import Process from "../components/CrossPlatformAppDevelopment/Process";
import IndustryBussinessjs from "../components/CrossPlatformAppDevelopment/IndustryBussinessjs";
import Commitment from "../components/CrossPlatformAppDevelopment/Commitment";
import Customers from "../components/CrossPlatformAppDevelopment/Customers";
import Success from "../components/CrossPlatformAppDevelopment/Success";
import PageTitle from "../components/CrossPlatformAppDevelopment/PageTitle";

import '../assets/Webdevelopment.css';



const CrossPlatformAppDevelopment = () => {
	return(
		<div className="App">
			<PageTitle />
	    	<Hero />
	    	<DevelopServices />
	    	<Technology />
	    	<Process />
	    	<IndustryBussinessjs />
	    	<Commitment />
	    	<Customers/>
	    	<Success />
	  </div>
	)
}

export default CrossPlatformAppDevelopment;
